import React from 'react'
import { Link } from 'react-router-dom'

const CHANGE_EMAIL_HELP_URL = 'https://help.plickers.com/hc/en-us/articles/4415750590363-How-to-change-the-email-address-linked-to-your-Plickers-account'

// Shown instead of the new-email form for accounts with Google/Apple sign-in
// linked: the account email has to match that Google/Apple email, so it can't
// be changed here — it's done from the account page instead (the help page
// walks through it), with support as the fallback for anyone who no longer
// has access to that Google/Apple account.
const EmailVerificationUpdateEmailUnavailable = (props) => {
  const { externalSigninName, onBack, onGoToAccountPage } = props

  return (
    <div className='emailVerificationFlow-backupOffer emailVerificationFlow-updateEmailUnavailable'>
      {onBack && (
        <button type='button' className='emailVerificationFlow-backBtn' onClick={onBack}>
          ← Back
        </button>
      )}
      <div className='emailVerificationFlow-title'>Update account email address</div>
      <div className='emailVerificationFlow-description'>
        {`Your account email address is linked to Sign in with ${externalSigninName}. To change it, please go to `}
        <Link to='/account' onClick={onGoToAccountPage}>your account page</Link>
        {'. See our '}
        <a href={CHANGE_EMAIL_HELP_URL} target='_blank' rel='noopener noreferrer'>help page</a>
        {' for more information.'}
      </div>
      <div className='emailVerificationFlow-description'>
        {`If you no longer have access to your ${externalSigninName} account, contact `}
        <a href='mailto:support@plickers.com'>support@plickers.com</a>
        .
      </div>
    </div>
  )
}

export default EmailVerificationUpdateEmailUnavailable
